import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LoadingMessageComponent } from '../loading-message/loading-message.component';

@Component({
    selector: 'app-full-loading',
    imports: [CommonModule, LoadingMessageComponent],
    templateUrl: './full-loading.component.html',
    styleUrls: ['./full-loading.component.scss']
})
export class FullLoadingComponent {
  @Input('backdrop') backdropProps: boolean | undefined = false;
  @Input('blur') blurProps: boolean | undefined = false;
}
